module.exports = __webpack_public_path__ + "assets/img/raku1.0a02005a.svg";